import './App.css';
import './Helper.js';
import Home from './components/Home';
import About from './components/About';
import Capabilities from './components/Capabilities';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Home />
      <About />
      <Capabilities />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
